import { useEffect, useState } from "react";

import { CRTBarrelClip } from "./components/CRTBarrelClip";
import { Footer } from "./components/Footer";
import { Nav } from "./components/Nav";
import { SecretOverflow } from "./components/SecretOverflow";
import { useCursorSparkles } from "./hooks/useCursorSparkles";
import { About } from "./sections/About";
import { CauldronHero } from "./sections/CauldronHero";
import { Contact } from "./sections/Contact";
import { Services } from "./sections/Services";
import { Work } from "./sections/Work";

export default function MarketingSite() {
  useCursorSparkles();

  const [overflow, setOverflow] = useState(false);
  useEffect(() => {
    if (!overflow) return;
    const t = setTimeout(() => setOverflow(false), 3500);
    return () => clearTimeout(t);
  }, [overflow]);

  return (
    <div className="scanlines crt-flicker">
      <CRTBarrelClip />
      <Nav />
      <main>
        <CauldronHero onSecretClicks={() => setOverflow(true)} />
        <Services />
        <Work />
        <About />
        <Contact />
      </main>
      <Footer />
      <SecretOverflow active={overflow} />
    </div>
  );
}
